export default __webpack_public_path__ + "static/media/video.116c3902.svg";